import { render, staticRenderFns } from "./v-textarea-field.vue?vue&type=template&id=5ab03acc&scoped=true&"
import script from "./v-textarea-field.vue?vue&type=script&lang=js&"
export * from "./v-textarea-field.vue?vue&type=script&lang=js&"
import style0 from "./v-textarea-field.vue?vue&type=style&index=0&id=5ab03acc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab03acc",
  null
  
)

export default component.exports